import React from 'react';
import { Heart, Shield, Sparkles } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const whyChooseData = [
  {
    icon: Heart,
    title: "Retour Affectif Garanti",
    description: "Les rituels du Grand Marabout garantissent le retour de votre ex. Des milliers de couples réunis témoignent de son efficacité.",
    color: "from-red-600 to-red-800",
  },
  {
    icon: Shield,
    title: "25 Ans d'Expérience",
    description: "Fort de ses 25 ans de pratique, Le Grand Marabout est reconnu comme l'un des marabouts les plus sérieux et efficaces de France.",
    color: "from-amber-600 to-amber-800",
  },
  {
    icon: Sparkles,
    title: "Résultats Rapides",
    description: "Les premiers signes apparaissent sous 7 jours. Votre ex vous recontacte par message, appel ou visite. Résultats garantis.",
    color: "from-purple-600 to-purple-800",
  },
];

const WhyChooseSection = () => (
  <section className="py-10 bg-gradient-to-b from-zinc-950 to-black">
    <div className="container mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-4xl font-bold mb-3 bg-gradient-to-r from-amber-200 via-amber-400 to-amber-200 bg-clip-text text-transparent">
          Pourquoi Choisir Le Grand Marabout ?
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {whyChooseData.map((item) => {
          const IconComponent = item.icon;
          return (
            <Card
              key={item.title}
              className="bg-gradient-to-br from-zinc-900 to-black border-amber-600/30 hover:border-amber-500/60 transition-all duration-300 transform hover:scale-105 hover:shadow-xl hover:shadow-amber-500/20"
            >
              <CardContent className="p-6 text-center">
                <div className={`w-16 h-16 bg-gradient-to-br ${item.color} rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg`}>
                  <IconComponent size={28} className="text-white" />
                </div>
                <h3 className="text-lg font-bold text-amber-400 mb-3">{item.title}</h3>
                <p className="text-amber-100/70 text-sm leading-relaxed">{item.description}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhyChooseSection;
